import { createFileRoute } from "@tanstack/react-router";
import { OffersPage } from "../features/offers/offers-page";
import { Require } from "../features/require";

/** More > Offers (P9-T08). */
export const Route = createFileRoute("/more/offers/")({ component: Page });

function Page() {
	return (
		<Require permission="offers.manage">
			<OffersPage />
		</Require>
	);
}
